export const messagesData = [
    {
      id: 1,
      name: "Eileen Ding",
      email:"eileending21@getDefaultNormalizer.com",
      company: "Shenzhen Great Asia Electronic Co.",
      date: "2024-11-5",
      message: "Order message",
      online_status: true,
      avatar: "https://images.pexels.com/photos/771742/pexels-photo-771742.jpeg",
      isUnread: true, 
      message: [
        { user: "hello", me: "hello sir, how can I help you?" },
        { user: "I need help with my order", me: "Sure, can you provide more details?" },
        { user: "I placed an order yesterday, but I haven't received a confirmation.", me: "Let me check that for you. Can you share your order ID?" },
        { user: "I don’t have the order ID right now.", me: "No worries. Can you provide your email or phone number used for the order?" },
      ],
    },
    {
      id: 2,
      name: "Steven Xie",
      email:"stevenxie22@gmail.com",
      company: "Zhengzhou Jian'en Trading Co., Ltd.",
      date: "2024-10-28",
      message: "Message",
      online_status: true,
      avatar: "https://images.pexels.com/photos/771742/pexels-photo-771742.jpeg",
      isUnread: true,
      message: [
        { user: "My email is user@example.com.", me: "Thank you! I'll look into it. Please hold on for a moment." },
        { user: "Sure, take your time.", me: "I’ve found your order. It is currently being processed and should be confirmed shortly." },
        { user: "Thank you for the update!", me: "You're welcome! Is there anything else I can assist you with?" },
        { user: "No, that's all for now.", me: "Great! Have a wonderful day." },
      ],
    },
    {
      id: 3,
      name: "Dylan Woo",
      email:"dylanwoo16@getDefaultNormalizer.com",
      company: "Shenzhen Gator Communication Co.",
      date: "2024-10-26",
      message: "Message",
      online_status: "",
      avatar: "https://images.pexels.com/photos/771742/pexels-photo-771742.jpeg",
      isUnread: false,
      message: [
        { user: "My email is user@example.com.", me: "Thank you! I'll look into it. Please hold on for a moment." },
        { user: "Sure, take your time.", me: "I’ve found your order. It is currently being processed and should be confirmed shortly." },
        { user: "I placed an order yesterday, but I haven't received a confirmation.", me: "Let me check that for you. Can you share your order ID?" },
        { user: "I don’t have the order ID right now.", me: "No worries. Can you provide your email or phone number used for the order?" },
      ],
    },
  ];    